import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'


const dataInicial = {
    diasDeAtencionAlmacen: [],
    diasDeAtencionProduccion: [],
    diasDeAtencionEnvasado: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_DIAS_ALMACEN = 'GET_DIAS_ALMACEN'
const INSERT_DIAS_ALMACEN = 'INSERT_DIAS_ALMACEN'
const UPDATE_DIAS_ALMACEN = 'UPDATE_DIAS_ALMACEN'

const GET_DIAS_PRODUCCION = 'GET_DIAS_PRODUCCION'
const INSERT_DIAS_PRODUCCION = 'INSERT_DIAS_PRODUCCION'
const UPDATE_DIAS_PRODUCCION = 'UPDATE_DIAS_PRODUCCION'

const GET_DIAS_ENVASADO = 'GET_DIAS_ENVASADO'
const INSERT_DIAS_ENVASADO = 'INSERT_DIAS_ENVASADO'
const UPDATE_DIAS_ENVASADO = 'UPDATE_DIAS_ENVASADO'
//*******************************************************************************************************************





//METODOS ALMACEN
export const getDiasDeAlmacen = createAsyncThunk(
    GET_DIAS_ALMACEN,
    async () => {
        try {
            const fullUrl = host + `UnidadAlmacenUbicacionDias/obtenerUnidadesAlmacenUbicacionDias`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertDiasDeAlmacen = createAsyncThunk(
    INSERT_DIAS_ALMACEN,
    async (data) => {
        try {
            const fullUrl = host + `UnidadAlmacenUbicacionDias/agregarUnidadAlmacenUbicacionDias`
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const updateDiasDeAlmacen = createAsyncThunk(
    UPDATE_DIAS_ALMACEN,
    async (data) => {
        try {
            const fullUrl = host + `UnidadAlmacenUbicacionDias/actualizarUnidadAlmacenUbicacionDias`
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

//METODOS PRODUCCION
export const getDiasDeProduccion = createAsyncThunk(
    GET_DIAS_PRODUCCION,
    async () => {
        try {
            const fullUrl = host + `UnidadProduccionUbicacionDias/obtenerUnidadesProduccionUbicacionDias`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertDiasDeProduccion = createAsyncThunk(
    INSERT_DIAS_PRODUCCION,
    async (data) => {
        try {
            const fullUrl = host + `UnidadProduccionUbicacionDias/agregarUnidadProduccionUbicacionDias`
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const updateDiasDeProduccion = createAsyncThunk(
    UPDATE_DIAS_PRODUCCION,
    async (data) => {
        try {
            const fullUrl = host + `UnidadProduccionUbicacionDias/actualizarUnidadProduccionUbicacionDias`
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

//METODOS ENVASADO
export const getDiasDeEnvasado = createAsyncThunk(
    GET_DIAS_ENVASADO,
    async () => {
        try {
            const fullUrl = host + `UnidadEnvasadoUbicacionDias/obtenerUnidadesEnvasadoUbicacionDias`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertDiasDeEnvasado = createAsyncThunk(
    INSERT_DIAS_ENVASADO,
    async (data) => {
        try {
            const fullUrl = host + `UnidadEnvasadoUbicacionDias/agregarUnidadEnvasadoUbicacionDias`
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const updateDiasDeEnvasado = createAsyncThunk(
    UPDATE_DIAS_ENVASADO,
    async (data) => {
        try {
            const fullUrl = host + `UnidadEnvasadoUbicacionDias/actualizarUnidadEnvasadoUbicacionDias`
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)



//****************************************************************************************************************
//EXPORTS DE MÉTODOS

export const metodosDiasDeAtencionSlice = createSlice({

    name: 'metodosDiasDeAtencionSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {

        [getDiasDeAlmacen.fulfilled]: (state, { payload }) => {
            state.diasDeAtencionAlmacen = payload.data.data
        },
        [getDiasDeEnvasado.fulfilled]: (state, { payload }) => {
            state.diasDeAtencionEnvasado = payload.data.data
        },
        [getDiasDeProduccion.fulfilled]: (state, { payload }) => {
            state.diasDeAtencionProduccion = payload.data.data
        },
        [insertDiasDeAlmacen.fulfilled]: (state, { payload }) => {
        },
        [insertDiasDeEnvasado.fulfilled]: (state, { payload }) => {
        },
        [insertDiasDeProduccion.fulfilled]: (state, { payload }) => {
        },
        [updateDiasDeAlmacen.fulfilled]: (state, { payload }) => {
        },
        [updateDiasDeEnvasado.fulfilled]: (state, { payload }) => {
        },
        [updateDiasDeProduccion.fulfilled]: (state, { payload }) => {
        }
    },

})

export const { } = metodosDiasDeAtencionSlice.actions
export const DiasDeAtencionReducer = metodosDiasDeAtencionSlice.reducer